import { render, staticRenderFns } from "./createMenu.vue?vue&type=template&id=4ef46490"
import script from "./createMenu.vue?vue&type=script&lang=js"
export * from "./createMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports